// @flow
import React, { Component } from "react";
import css from "./field.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Validator } from "../services/validators";

type Props = {
  type: string,
  name: string,
  data: Object,
  title: string,
  description: string,
  onChange: Function,
  placeholder?: string,
  errorFields: Array<string>,
  options?: Array<*>,
  defaultValue?: *,
  requiredFields: Array<string>,
  isDisabled: boolean,
  maxLength: number,
  validator: Function,
  textAreaRows: number,
  min: number,
  max: number,
  step: number,
};

export class Field extends Component<Props> {
  static defaultProps: Object = {
    type: "text",
    hasError: false,
    required: true,
    isDisabled: false,
  };

  constructor(props: Object) {
    super(props);
    if (props.validator) {
      Validator[props.name] = props.validator;
    }
  }
  render(): Object {
    const data = this.props.data;
    const name = this.props.name;

    const isValidated = Validator[name] && Validator[name](data && data[name]);

    let hasError = false;

    // console.log(this.props.errorFields)
    if (this.props.errorFields) {
      //  hasError =  this.props.errorFields && this.props.errorFields.includes(name)

      if (this.props.errorFields.indexOf(name) !== -1) {
        hasError = true;
      }
    }
    // const required = this.props.required && this.props.required.includes(name)

    let required = false;
    if (this.props.requiredFields.indexOf(name) !== -1) {
      required = true;
    }

    // const status = hasError ? css.statusError : isValidated ? css.statusValidated : css.statusPending;

    const status = isValidated
      ? css.statusValidated
      : hasError
      ? css.statusError
      : css.statusPending;

    const icon = hasError && !isValidated ? faTimes : faCheck;

    const border = isValidated
      ? css.borderValidated
      : hasError
      ? css.borderError
      : null;

    let input = null;

    switch (this.props.type) {
      case "textarea": {
        input = (
          <textarea
            className={[css.input, border].join(" ")}
            rows={this.props.textAreaRows || 4}
            disabled={this.props.isDisabled}
            onChange={this.props.onChange}
            value={data[name] || ""}
            maxLength={this.props.maxLength}
            name={name}
          ></textarea>
        );
        break;
      }
      case "select": {
        input = (
          <select
            disabled={this.props.isDisabled}
            name={this.props.name}
            defaultValue={this.props.defaultValue}
            onChange={this.props.onChange}
          >
            {this.props.options}
          </select>
        );
        break;
      }
      case "number": {
        input = (
          <input
            className={[css.input, border].join(" ")}
            type={this.props.type}
            value={data[name] || this.props.defaultValue}
            // defaultValue={this.props.defaultValue}
            name={this.props.name}
            disabled={this.props.isDisabled}
            onChange={this.props.onChange}
            placeholder={this.props.placeholder}
            min={this.props.min}
            max={this.props.max}
            step={this.props.step}
          />
        );
        break;
      }
      default: {
        input = (
          <input
            className={[css.input, border].join(" ")}
            type={this.props.type}
            value={data[name] || ""}
            // defaultValue={this.props.defaultValue}
            name={this.props.name}
            disabled={this.props.isDisabled}
            onChange={this.props.onChange}
            placeholder={this.props.placeholder}
          />
        );
      }
    }

    return (
      <div className={css.field}>
        <div className={css.title}>
          {required && "*"}
          {this.props.title}
        </div>
        {input}
        {icon && (
          <div className={css.statusIconWrapper}>
            <FontAwesomeIcon
              className={[css.statusIcon, status].join(" ")}
              icon={icon}
            />
          </div>
        )}
        <div className={css.description}> {this.props.description} </div>
      </div>
    );
  }
}
export default Field;
